import Breadcrumb from "../components/Breadcrumb";
import ClinetRoles from "../components/ClinetRoles";

const ClientRolePage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Client Roles" />

      {/*clients roles page*/}
      <ClinetRoles />
    </>
  );
};

export default ClientRolePage;
